import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=c04c84fe"
import script from "./UpdateNotification.vue?vue&type=script&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotification.vue?vue&type=style&index=0&id=c04c84fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports